import { useState } from "react";
import { useTranslation } from "react-i18next";
import Status from "../../enums/Status";
import FormFieldValidation from "../../enums/FormFieldValidation";
import sarService from "../../services/sarService";
import { Alert, Button, Card, Col, Container, Row } from "react-bootstrap";
import LargeFloatingTextField from "../../components/formFields/largeFloatingText/LargeFloatingTextField";

interface IAppealProps {
    requestId: string;
    rejectionReason: string;
}

export default function Appeal(props: IAppealProps) {
    const { t } = useTranslation();

    const [status, setStatus] = useState<Status>(Status.NEUTRAL);
    const [reason, setReason] = useState<string>("");
    const [reasonValidation, setReasonValidation] = useState<FormFieldValidation>(FormFieldValidation.NOT_VALIDATED);

    const handleReasonChange = (reason: string) => setReason(reason);

    const handleAppealClicked = async () => {
        if (!reason?.trim()) {
            setReasonValidation(FormFieldValidation.INVALID);
            return;
        }

        setStatus(Status.SAVING);
        setReasonValidation(FormFieldValidation.VALID);
        
        const success = await appeal(props.requestId, reason);

        if (success) {
            setStatus(Status.SAVE_SUCCESS);
        } else {
            setStatus(Status.SAVE_ERROR);
        }
    };

    const isDisabled = [Status.SAVING, Status.SAVE_SUCCESS].includes(status);

    return (
        <Card.Body className="pt-0">
            <Card.Text as="div">
                <Container fluid>
                    <Row>
                        <Col>
                            <h2 className="h4">
                                {t("dsar.appeal.header")}
                            </h2>
                            <p>
                                <strong>{t("dsar.appeal.reason")}</strong>
                            </p>
                            <pre style={{ fontFamily: "inherit" }}>{props.rejectionReason}</pre>
                            <LargeFloatingTextField required
                                height={100}
                                type="textarea"
                                value={reason}
                                disabled={isDisabled}
                                onChange={handleReasonChange}
                                label={t("dsar.appeal.form.fields.reason.label")}
                                validation={reasonValidation}
                                validationMessage={t("dsar.appeal.form.fields.reason.validation")}
                                />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {
                                status !== Status.SAVE_SUCCESS &&
                                <Button
                                    className="mb-3"
                                    variant="primary"
                                    disabled={isDisabled}
                                    onClick={handleAppealClicked}
                                    >
                                        {t("dsar.appeal.btnSubmit")}
                                </Button>
                            }
                            {
                                status === Status.SAVING &&
                                <Alert variant="info">
                                    {t("general.pleaseWait")}
                                </Alert>
                            }
                            {
                                status === Status.SAVE_SUCCESS &&
                                <Alert variant="success">
                                    {t("dsar.success.appeal")}
                                </Alert>
                            }
                            {
                                status === Status.SAVE_ERROR &&
                                <Alert variant="danger">
                                    {t("dsar.errors.appeal")}
                                </Alert>
                            }
                        </Col>
                    </Row>
                </Container>
            </Card.Text>
        </Card.Body>
    );
}

async function appeal(id: string, reason: string) {
    try {
        const result = await sarService.appealSAR(id, reason);
        return result;
    } catch (e) {
        return false;
    }
}